import { StyledButtonListToggler } from './ButtonListToggler.style';
import { Button, ButtonGroup } from '@material-ui/core';
import MultiOptionsPicker from './MultiOptionsPicker';
import { noop } from 'lodash';

const ButtonListToggler = ({ list = [], value, onChange = noop, max }) => {
  const listInView = max ? list.slice(0, max - 1) : list;
  const remainingList = max ? list.slice(listInView.length, list.length) : [];

  return (
    <StyledButtonListToggler>
      <ButtonGroup disableElevation variant='contained'>
        {listInView.map(item => {
          const isSelected = item.value === value;
          return (
            <Button
              key={item.value}
              variant={isSelected ? 'contained' : 'outlined'}
              onClick={() => onChange(item)}
            >
              {item.name}
            </Button>
          );
        })}

        <MultiOptionsPicker
          options={remainingList}
          value={value}
          onChange={onChange}
        />
      </ButtonGroup>
    </StyledButtonListToggler>
  );
};

export default ButtonListToggler;
